export default __webpack_public_path__ + "static/car_woman-e2a28ad477dcc0b09ba3326594e51df7.jpg";